import { type Quiz } from '../defs/quiz';

/**
 * Checks if we are in the Plan Recommender variant and verifies if totalPeople is > 0
 * In the Control group, checks if householdSize is not null
 * @param quiz
 * @returns
 */
export function hasMetQuizHelloRequirements(
  quiz: Quiz | undefined | null
): undefined | boolean {
  if (!quiz) {
    return;
  }

  const hasHouseholdSize = quiz.householdSize !== null;

  return hasHouseholdSize;
}
